import React, { useState } from "react";
import themeStyles from "../../shared/styles/theme/theme-styles.module.scss";
import styles from "./styles.module.scss";
import InputGroup from "../components/inputGroup/InputGroup";

const PasswordForm = (props) => {
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);

  const handleEyeClick = () => {
    setIsPasswordHidden(!isPasswordHidden);
  };

  const handleSubmit = async (e, values) => {
    e.preventDefault();
    await props.setTouched(
      Object.keys(values).reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
      }, {}),
      true
    );

    if (
      Object.keys(props.touched).length > 0 &&
      !Object.keys(props.errors).length > 0
    ) {
      props.handleSubmit(values);
      console.log(values);
    }
  };

  const { errors, handleChange, handleBlur, touched, values } = props;
  const { oldPassword, password, confirmPassword } = values;

  return (
    <div className={styles.containerForm}>
      <form>
        <fieldset className={styles.field}>
          <label className={styles.title}>{"Change Password"}</label>
          <div className={styles.section}>
            <div className={styles.column}>
              <InputGroup
                inputType={isPasswordHidden ? "password" : "text"}
                name="oldPassword"
                label={"Old Password"}
                leftMargin={false}
                touched={touched}
                errors={errors}
                onBlur={handleBlur}
                inputValue={oldPassword}
                onChange={handleChange}
                onClick={handleEyeClick}
                className={styles.input}
              />
            </div>
            <div className={styles.column}>
              <InputGroup
                inputType={isPasswordHidden ? "password" : "text"}
                name="password"
                label={"New Password"}
                leftMargin={false}
                touched={touched}
                errors={errors}
                onBlur={handleBlur}
                inputValue={password}
                onChange={handleChange}
                onClick={handleEyeClick}
                className={styles.input}
              />
            </div>
            <div className={styles.column}>
              <InputGroup
                inputType={isPasswordHidden ? "password" : "text"}
                name="confirmPassword"
                label={"Confirm Password"}
                leftMargin={false}
                touched={touched}
                errors={errors}
                onBlur={handleBlur}
                inputValue={confirmPassword}
                onChange={handleChange}
                onClick={handleEyeClick}
                className={styles.input}
              />
            </div>
          </div>
        </fieldset>
        <div className={styles.buttonRow}>
          <button
            className={`${themeStyles.btnPrimaryLT}`}
            type="submit"
            onClick={(e) => handleSubmit(e, values)}
            disabled={
              Object.keys(props.errors).length > 0 ||
              Object.keys(props.touched).length === 0
            }
          >
            {"Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PasswordForm;
